<template>
    <div class="card-surface">
        <div class="card-surface-title">
            <h3 class="label-xl">Requirements</h3>
        </div>
        <div class="card-surface-container">
            <CardResourcesComponent :resources="this.resources" title=""/>
            <hr />
            <ListMComponent v-for="(requeriment, index) in this.requeriments" 
                :key="index"
                :placeholder="requeriment.name"
                :label="requeriment.level"
                :class-variant="this.getClassVariant(requeriment)"
            />
        </div>
    </div>
</template>

<style scoped>
.card-surface {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: var(--border-radius-xs);
    border: 1px solid var(--border-1);
    background-color: var(--background-2);
    overflow: hidden;
    max-height: 300px;
}

.card-surface-title {
    display: flex;
    padding: 12px 16px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    background-color: var(--background-1);
}

.card-surface-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    height: min-content;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>

<script>
import CardResourcesComponent from './CardResourcesComponent.vue';
import ListMComponent from '../core/list/ListMComponent.vue';

export default {
    name: 'CardRequirementsComponent',
    components: {
        CardResourcesComponent,
        ListMComponent
    },
    props: {
        resources: {
            type: Array,
            required: true,
            default: () => [],
        },
        requeriments: {
            type: Array,
            required: true,
            default: () => [],
        }
    },
    methods: {
        getClassVariant(requeriment) {
            return requeriment.accomplish ? 0 : 1;
        }
    }
}
</script>